export const dataLayer = window && window.dataLayer ? window.dataLayer : { push: () => {} }
